module.exports = __webpack_public_path__ + "static/big-cube-3-be1a93811653378b59674e7b5317cd72.png";